import { useState } from "react";

/** The illustration of one Standard Pembelajaran (generated once, served from R2). Hidden when the picture is missing. */
export function LearnImage({ id, className = "", alt = "" }: { id?: string | undefined; className?: string; alt?: string }) {
  const [bad, setBad] = useState(false);
  if (!id || bad) return null;
  return <img src={`/api/learn/img/${id}`} alt={alt} loading="lazy" decoding="async" draggable={false} onError={() => setBad(true)} className={`select-none rounded-3xl bg-white object-cover ${className}`} />;
}
